import React from 'react'
import SbEditable from 'storyblok-react'
import Heading from 'src/components/Heading'
import RichText from 'src/utils/RichText'
import Button from 'src/components/Button'
import FluidImage from 'src/utils/FluidImage'

const CtaSplitWithImage = ({blok}) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div>
                <div className="relative" style={{ backgroundColor: blok.background_colour.color }}>
                    <div className="h-56 sm:h-72 md:absolute md:right-0 md:h-full md:w-1/2">
                        <FluidImage className="object-contain object-center w-full h-full" image={blok.image}/>
                    </div>
                    <div className="relative max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-24">
                        <div className="md:mr-auto md:w-1/2 md:pl-10">
                        <Heading size="h3" className="mt-2 text-white">{blok.title}</Heading>
                        <div className="mt-3 text-sm text-white">
                            <RichText>{blok.content}</RichText>
                        </div>
                        { blok.button_target.linktype === "story" ?
                        (<Button className="mt-8 text-white" target={blok.button_target.cached_url} style={{backgroundColor: blok.button_colour.color}}>
                           {blok.button_label}
                        </Button>)
                        :
                        (
                        <a className="mt-8 text-white cursor-pointer inline-flex justify-center items-center px-[30px] py-[14px] line-crop font-display tracking-normal uppercase transition duration-300 text-[1.3rem]" href={blok.button_target.cached_url} style={{backgroundColor: blok.button_colour.color}} target="_blank" rel="noreferrer">
                           {blok.button_label}
                           <i className="fas fa-chevron-right cursor-pointer ml-3 text-xs inline"></i>
                        </a>
                        )
}
                        </div>
                    </div>
                </div>
            </div>

        </SbEditable>
    )
}

export default CtaSplitWithImage
